import join from 'url-join';

import { http } from '../../util';

import { uppercase } from '../../util/uppercase';

const ordersPrefixV2 = join(import.meta.env.VITE_API2_URL, 'v1', '/orders');
const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const REQUEST_ORDERS = 'REQUEST_ORDERS';
export const CLEAR_ORDERS = 'CLEAR_ORDERS';
export const SELECT_ORDER = 'SELECT_ORDER';
export const SELECT_ALL_ORDERS = 'SELECT_ALL_ORDERS';
export const REQUEST_IDS_IN_PROGRESS = 'REQUEST_IDS_IN_PROGRESS';
export const CANCEL_REQUEST_IDS_IN_PROGRESS = 'CANCEL_REQUEST_IDS_IN_PROGRESS';
export const GENERATE_AVAILABILITY_REPORT = 'GENERATE_AVAILABILITY_REPORT';

export const requestOrders = {
  name: REQUEST_ORDERS,
  action: async ({ payload }) => {
    const response = await http.post(join(ordersPrefixV2, '/search'), payload);
    const { orders, pageNumber, totalRecords } = response.data;

    return {
      orders,
      pageNumber,
      totalRecords
    };
  }
};

export const requestRemainingOrderIds = async ({ payload, startIndex }) => {
  const response = await http.post(join(ordersPrefixV2, '/search'), {
    ...payload,
    page: {
      number: 1,
      size: 2000 // max size for route - but what if there are more than 2000 total?
    }
  });

  const remainingOrderIds = response.data.orders.map(o => o.id).slice(startIndex);

  return remainingOrderIds;
};

const getReportStatusAndUrl = async id =>
  new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      http
        .get(join(api2, `/reports/status/${id}`))
        .then(({ data }) => {
          const { reportStatus, downloadUrl } = data;
          if (reportStatus !== 'IN PROGRESS') {
            clearInterval(interval);
          }
          if (reportStatus === 'FAILED' || !downloadUrl) {
            throw new Error('Failed to generate report');
          }
          resolve(downloadUrl);
        })
        .catch(error => {
          clearInterval(interval);
          reject(error);
        });
    }, 2500);
  });

export const generateAvailabilityReport = {
  name: GENERATE_AVAILABILITY_REPORT,
  action: async ({ orderIds, orderType }) => {
    if (!orderIds?.length) {
      throw new Error('At least one order must be selected');
    }

    const capitalizedOrderType = uppercase(orderType);

    const response = await http.post(join(api2, `/reports/generate${capitalizedOrderType}Report`), { orderIds });

    const reportId = response.data.id;
    const downloadUrl = await getReportStatusAndUrl(reportId);

    if (downloadUrl instanceof Error) {
      throw downloadUrl;
    }

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  }
};
